import { FC } from 'react';
import { Modal, TextField } from 'melp-design/components';
import { Controller, SubmitHandler, useForm } from 'react-hook-form-latest';
import { useTranslation } from 'react-i18next';
import { useEditCustomCategory } from 'store/custom-categories';
import { ModalProps } from 'store/modal';
import { usePredefinedToasts } from 'utils/Toast';

interface Values {
  name: string;
}

interface Props extends ModalProps {
  categoryId: string;
  initialValues: Values;
}

export const EditCustomCategoryModal: FC<Props> = ({
  categoryId,
  initialValues,
  closeModal,
}) => {
  const { t } = useTranslation();
  const predefinedToasts = usePredefinedToasts();

  const { control, handleSubmit } = useForm<Values>({
    defaultValues: initialValues,
  });

  const { mutate: editCustomCategory, isLoading } = useEditCustomCategory();

  const onSubmit: SubmitHandler<Values> = (values) => {
    editCustomCategory(
      {
        categoryId,
        data: {
          name: values.name,
        },
      },
      {
        onSuccess: () => {
          closeModal();
          predefinedToasts.success.updated();
        },
      },
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Modal.Content
        title={t('automations.parameters.employeeCustomCategory')}
        actions={[
          {
            variant: 'neutral-outline',
            onClick: () => closeModal({ action: 'CLOSE' }),
            label: t('common.cancel'),
          },
          {
            variant: 'primary',
            label: t('common.confirm'),
            type: 'submit',
            disabled: isLoading,
          },
        ]}
      >
        <Controller
          name="name"
          control={control}
          render={({ field: { name, value, onChange, ref } }) => {
            return (
              <TextField
                placeholder={t('custom_employee_category.category_name')}
                name={name}
                value={value}
                onChange={onChange}
                required
                fullWidth
                ref={ref}
              />
            );
          }}
        />
      </Modal.Content>
    </form>
  );
};
